import { motion } from "framer-motion";
import { scrollToSection } from "@/lib/lenis";

export default function CTABand() {
  return (
    <section data-testid="cta-band" className="bg-[#12344E] py-20 lg:py-24 text-center">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="max-w-2xl mx-auto px-6"
      >
        <h2 className="text-3xl sm:text-4xl font-bold text-white leading-tight">
          Partner With Jamsac
        </h2>
        <p className="mt-5 text-base text-[#C9DAE8] leading-relaxed">
          We are always open to conversations with founders, investors and
          partners who share our long-term view of New Zealand enterprise.
        </p>
        <button
          data-testid="cta-band-button"
          onClick={() => scrollToSection("#contact")}
          className="mt-8 px-9 py-4 rounded-full bg-[#1F6191] text-white text-xs font-bold uppercase tracking-[0.12em] hover:bg-white hover:text-[#12344E] transition-colors duration-300"
        >
          Get In Touch
        </button>
      </motion.div>
    </section>
  );
}
